import { render, staticRenderFns } from "./bootstrapModals.vue?vue&type=template&id=43064cec&scoped=true&"
import script from "./bootstrapModals.vue?vue&type=script&lang=js&"
export * from "./bootstrapModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43064cec",
  null
  
)

export default component.exports